/**
 * Generates CSV content from an array of objects.
 * @param data - Array of data objects.
 * @param headers - Array of {key: string, label: string} for CSV header.
 * @returns CSV string.
 */
export const generateCsvContent = (
  data: any[],
  headers: { key: string; label: string }[]
): string => {
  if (!data || data.length === 0) return ''

  const headerRow = headers.map(h => h.label).join(',') + '\n'
  const dataRows = data
    .map(row => {
      return headers
        .map(header => {
          let cellValue = row[header.key]
          if (cellValue === null || cellValue === undefined) {
            cellValue = ''
          } else {
            cellValue = String(cellValue)
            cellValue = cellValue.replace(/\r\n|\r|\n/g, ' ')
            if (cellValue.includes('"') || cellValue.includes(',')) {
              cellValue = `"${cellValue.replace(/"/g, '""')}"`
            }
          }
          return cellValue
        })
        .join(',')
    })
    .join('\n')

  return headerRow + dataRows
}

/**
 * Triggers a browser download for the given CSV content.
 * @param csvContent - The CSV string.
 * @param fileName - The desired file name for the download.
 */
export const downloadCsv = (csvContent: string, fileName: string): void => {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const link = document.createElement('a')
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob)
    link.setAttribute('href', url)
    link.setAttribute('download', fileName)
    link.style.visibility = 'hidden'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  } else {
    alert(
      'CSV download is not fully supported in this browser. Please try a modern browser.'
    )
  }
}
